import React, { useEffect, useRef } from 'react';

function NotesCasesFilterPopup({ filters, onFilterChange, onReset, onClose }) {
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const filterGroups = [
    {
      id: 'status',
      title: 'Status',
      options: [
        { id: 'open', label: 'Open' },
        { id: 'closed', label: 'Closed' },
      ],
    },
    {
      id: 'type',
      title: 'Type',
      options: [
        { id: 'case', label: 'Cases' },
        { id: 'note', label: 'Notes' },
      ],
    },
  ];

  return (
    <div className="popup-dropdown filter-dropdown" ref={containerRef} style={{ left: '120px', width: '280px' }}>
      <div className="popup-dropdown-header">
        <span className="popup-title">Filters</span>
        <button type="button" className="reset-all-btn" onClick={onReset}>
          Reset All
        </button>
      </div>

      <div className="filter-groups-list">
        {filterGroups.map((group) => (
          <div key={group.id} className="filter-popup-group">
            <div className="filter-group-title">{group.title}</div>
            <div className="filter-group-options" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {group.options.map((opt) => {
                const isSelected = filters[group.id] === opt.id;
                return (
                  <button
                    key={opt.id}
                    type="button"
                    className={`filter-badge-btn ${isSelected ? 'active' : ''}`}
                    onClick={() => {
                      if (isSelected) {
                        onFilterChange(group.id, null);
                      } else {
                        onFilterChange(group.id, opt.id);
                      }
                    }}
                  >
                    {opt.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NotesCasesFilterPopup;
